
import Btn from "./Btn.vue";

export default {
    components: {Btn},
    data() {
        return {
            isCookiePopupVisible: localStorage.getItem('cookiePopupClosed') !== 'true'
        }
    },
    methods: {
        hidePopup() {
            this.isCookiePopupVisible = false
            localStorage.setItem('cookiePopupClosed', 'true')
        }
    },
}
